<template>
  <div>
    <div class="frequency">
      <p>
        您还剩<span style="color: #ffedcf">{{
          prizeNum != "" ? prizeNum : "0"
        }}</span
        >次抽奖机会
      </p>
    </div>
    <div class="title">
      <h5>{{ detalisData.actLotName }}</h5>
      <p>
        {{
          "活动时间" +
          detalisData.actLotBeginTime +
          "至" +
          detalisData.actLotEndTime
        }}
      </p>
    </div>
    <div style="background: #f02122">
      <div class="rules">
        <div class="tabs">
          <div class="tabs-first">
            <div
              :class="tabs == 1 ? 'Selected' : ''"
              :style="{ borderBottomRightRadius: tabs == 2 ? '10px' : '0' }"
              @click="handTabs(1)"
            >
              详情说明
            </div>
          </div>
          <div>
            <div
              :class="tabs == 2 ? 'Selected' : ''"
              :style="{
                borderBottomLeftRadius: tabs == 1 ? '10px' : '0',
                borderBottomRightRadius: tabs == 3 ? '10px' : '0',
              }"
              @click="handTabs(2)"
            >
              获奖名单
            </div>
          </div>
          <div class="tabs-last">
            <div
              :class="tabs == 3 ? 'Selected' : ''"
              :style="{ borderBottomLeftRadius: tabs == 2 ? '10px' : '0' }"
              @click="handTabs(3)"
            >
              我的奖品
            </div>
          </div>
        </div>
        <div v-if="tabs == 1" class="content">
          <img
            src="../assets/interacactiveLottery/rules.png"
            alt=""
            class="content-rules"
          />
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="detalisData.actLotRule"
            :autosize="{ minRows: 2, maxRows: 999 }"
            readonly
          >
          </el-input>
          <img
            src="../assets/interacactiveLottery/details.png"
            alt=""
            class="content-rules"
            style="margin-top: 0.53rem"
          />
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="detalisData.actLotAnnotation"
            :autosize="{ minRows: 2, maxRows: 999 }"
            readonly
          >
          </el-input>
        </div>
        <div v-if="tabs == 2" class="content cont-prize">
          <div class="winPrize">
            <van-list
              ref="winPrize"
              v-if="winPrizeList.length > 0"
              v-model:loading="winPrizeloading"
              :immediate-check="false"
              :finished="winPrizefinished"
              finished-text="没有更多了"
              @load="winPrizeLoad"
              :offset="500"
            >
              <van-cell v-for="(item, index) in winPrizeList" :key="index">
                <el-image
                  :src="item.url"
                  fit="cover"
                  class="winPrizeimg"
                  style="width: 0.84rem; height: 0.84rem"
                >
                  <img
                    class="winPrizeimg"
                    style="object-fit: cover"
                    :src="require('../assets/img/portrait.png')"
                    slot="error"
                  />
                </el-image>
                <div class="winPrize-title">
                  <div>
                    <p class="name">{{ item.webUserName }}</p>
                    <p class="time">{{ item.createTime }}</p>
                  </div>
                  <span
                    style="
                      width: 45%;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      text-align: right;
                    "
                    >{{ "抽中" + item.actPriName }}</span
                  >
                </div>
              </van-cell>
            </van-list>
            <img
              class="default"
              src="../assets/interacactiveLottery/default.png"
              alt=""
              v-else
            />
          </div>
        </div>
        <div v-if="tabs == 3" class="content cont-prize">
          <div class="winPrize myPrize">
            <van-list
              v-if="myPrizeList.length > 0"
              v-model:loading="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              :offset="500"
            >
              <van-cell v-for="(item, index) in myPrizeList" :key="index">
                <!-- <img :src="item.url" alt="" class="myPrizeimg" /> -->
                <el-image :src="item.url" fit="cover" class="myPrizeimg">
                  <img
                    class="myPrizeimg"
                    style="object-fit: cover"
                    :src="require('@/assets/img/background.png')"
                    slot="error"
                  />
                </el-image>
                <div>
                  <p class="name">{{ item.actPriName }}</p>
                  <el-button type="success" round @click="showDetails(item)"
                    >查看</el-button
                  >
                </div>
              </van-cell>
            </van-list>
            <img
              class="default"
              src="../assets/interacactiveLottery/default.png"
              alt=""
              v-else
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLotDetail,
  getLotWinnerPage,
  getLotWinnerMy,
  getLotUserCount,
  getLotPv,
} from "../api/InteractiveLottery";
import { filePerviewPath } from "@/api/globalApi.js";
import { List } from "vant";
// import Bus from "../utils/bus";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      winPrizeloading: false,
      winPrizefinished: false,
      tabs: 1,
      content:
        "1000积分即可兑换一次抽奖机会，每人每天都可抽奖1次。\n抽奖时间：10月25日-31日晚24点\n商品详情\n奖品包括《醒醒！》环保主题系列绘本 一本\n活动规则\n抽中奖品后，请填写用户信息，在三天内联系川观积分福利官（cgjf2020)。\n可选择自提和邮寄两种方式领取。\n领奖方式：自提\n领取地点：成都市锦江区红星路二段70号四川日报报业大厦14楼B区\n领取时间：工作日上午10时-12时、下午3时-6时\n积分兑换商品数量有限，换完为止；商品兑换完成后不可撤销；兑换后两周内未领取视为主动放弃。\n本活动最终解释权归川观新闻所有",
      winPrizeList: [],
      myPrizeList: [],
      detalisData: {},
      mywinnerNum: 0,
      winnerNum: 0,
      prizeNum: "",
      token: "",
    };
  },

  created() {
    this.getDetails(this.$route.query.actLotId);
    if (localStorage.getItem("token") != null) {
      this.getLotUser();
    }
    setTimeout(() => {
      this.recordViwes(this.$route.query.actLotId);
    }, 5000);
  },
  mounted() {
    this.$bus.$on("num", (data) => {
      this.prizeNum = data;
    });
  },
  methods: {
    handTabs(val) {
      this.tabs = val;
      if (val == 2) {
        //获奖名单
        this.winnerNum = 0;
        this.winPrizeList = [];
        this.winPrizefinished = false;
        this.winPrizeLoad();
      } else if (val == 1) {
        this.getDetails(this.$route.query.actLotId);
      } else if (val == 3) {
        if (localStorage.getItem("token") != null) {
          // this.getMywinnerPage(1);
          //我的中奖
          this.mywinnerNum = 0;
          this.myPrizeList = [];
          this.finished = false;
          this.onLoad();
        }
      }
    },
    //获取我的中奖记录
    getMywinnerPage(val) {
      getLotWinnerMy({
        actLotId: this.$route.query.actLotId,
        pageNum: val,
      }).then(({ data }) => {
        if (data.code == 200) {
          if (data.data.list.length > 0) {
            this.myPrizeList.push(...data.data.list);
            this.myPrizeList.forEach((ele) => {
              let obj = {
                fileObjId: ele.actPriFileObjId,
                downType: "cover",
              };
              ele.url = filePerviewPath(obj);
            });
          } else {
            // 数据全部加载完成
            this.finished = true;
          }
        }
      });
    },
    onLoad() {
      console.log("建在");
      // 异步更新数据
      this.mywinnerNum++;
      this.getMywinnerPage(this.mywinnerNum);
      // 加载状态结束
      this.loading = false;
    },
    //获奖名单
    getWinnerPage(val) {
      getLotWinnerPage({
        actLotId: this.$route.query.actLotId,
        pageNum: val,
      }).then(({ data }) => {
        if (data.code == 200) {
          if (data.data.list.length > 0) {
            this.winPrizeList = [...this.winPrizeList, ...data.data.list];
            this.winPrizeList.forEach((ele) => {
              let obj = {
                fileObjId: ele.webUserAvatar,
                downType: "cover",
              };
              ele.url = filePerviewPath(obj);
            });
          } else {
            this.winPrizefinished = true;
          }
        }
      });
    },
    winPrizeLoad() {
      console.log("dy");
      // 异步更新数据
      this.winnerNum++;
      this.getWinnerPage(this.winnerNum);
      // 加载状态结束
      this.winPrizeloading = false;
    },
    //查看详情
    showDetails(val) {
      this.$router.push({
        path: "/WinningDetails",
        query: { data: val },
      });
    },
    //获取详情
    getDetails(val) {
      getLotDetail({ actLotId: val }).then(({ data }) => {
        if (data.code == 200) {
          this.detalisData = data.data;
        }
      });
    },
    //获取获奖次数
    getLotUser() {
      getLotUserCount({ actLotId: this.$route.query.actLotId }).then(
        ({ data }) => {
          if (data.code == 200) {
            // console.log(data.data);
            this.prizeNum = data.data;
          }
        }
      );
    },
    //记录浏览量
    recordViwes(val) {
      getLotPv({ actLotId: val }).then(({ data }) => {});
    },
  },
};
</script>

<style scoped>
.frequency {
  text-align: center;
  margin: 20px 0;
}
.frequency > p {
  border-radius: 29px;
  line-height: 29px;
  font-size: 14px;
  border: none;
  width: 55%;
  letter-spacing: 5px;
  background: #fc674f;
  color: #ffffff;
  margin: 0 auto;
}
.frequency > p > span {
  font-size: 18px;
}
.title {
  width: 90%;
  margin: 0 auto;
  background: #fffbf1;
  border-radius: 10px;
  color: #bf3100;
  padding: 16px;
  box-sizing: border-box;
}
.title > h5 {
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 11px;
}
.title > p {
  font-size: 14px;
  line-height: 21px;
}

.rules {
  width: 90%;
  margin: 20px auto;
  padding-bottom: 0.8rem;
}
.tabs {
  display: flex;
  width: 100%;
  background: #fff5da;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.tabs > div {
  width: 33.33%;
  font-size: 14px;
  text-align: center;
  height: 33px;
  line-height: 33px;
  background: #fffbf1;
  color: #bf3100;
}
.tabs .tabs-first > div,
.tabs .tabs-first {
  border-top-left-radius: 10px;
}
.tabs .tabs-last > div,
.tabs .tabs-last {
  border-top-right-radius: 10px;
}
.tabs > div > div {
  background: #fff5da;
}
.Selected {
  line-height: 42px !important;
  background: #fffbf1 !important;
  margin-top: -10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-size: 18px;
  font-weight: 600;
}
.content {
  /* height: 5rem; */
  background: #fffbf1;
  padding: 20px;
  text-align: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  /* height: 624px; */
  min-height: 6.5rem;
  margin-top: -3px;
  /* margin-top: -0.1rem; */
}
.content-rules {
  width: 55%;
}
/deep/ .el-textarea__inner {
  border: none !important;
  background: none !important;
  color: #333333 !important;
  line-height: 24px !important;
  padding: 0 !important;
  font-size: 14px;
  overflow-y: hidden;
  resize: none;
}
.cont-prize {
  padding: 0px;
}
.van-cell {
  padding: 19px 20px;
}
.van-cell__value {
  display: flex;
  align-items: center;
}
.van-cell__value > img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.winPrize .van-cell__value > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.myPrize .van-cell__value > div {
  display: flex;
  align-items: center;
  width: 80%;
  justify-content: space-between;
  /* margin-right: 12px; */
}
.name,
.winPrize .van-cell__value span {
  color: #bf3100;
}
.name {
  font-size: 16px;
  font-weight: 600;
  /* margin-bottom: 0.13rem; */
  margin-left: 0.24rem;
}
.winPrize .van-cell__value span {
  font-size: 14px;
  /* margin-right: 0.53rem; */
}
.winPrize {
  /* max-height: 624px; */
  position: relative;
  /* overflow-y: auto; */
  /* height: 100%; */
  min-height: 6.5rem;
}
.winPrizeimg {
  border-radius: 50%;
  width: 0.84rem;
  height: 0.84rem;
}
.winPrize > .winPrizeimg {
  width: 2.56rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -60%);
}
.time {
  font-size: 12px;
  color: #d6c1ba;
}
.myPrize li img {
  width: 1.86rem;
  border-radius: 0.13rem;
}
.myPrize li:last-child {
  border-bottom: none;
}
.myPrize li > div {
  margin-left: 0.32rem;
  margin-right: 0.53rem;
}
/deep/.myPrize .el-button {
  background: linear-gradient(89.84deg, #ff8f4a 1.54%, #fe2a17 97%) !important;
  border: none !important;
  padding: 0.12rem 0.28rem !important;
}
.myPrizeimg {
  width: 1.4rem !important;
  height: 1.4rem !important;
  border-radius: 0.13rem !important;
}
.winPrize-title {
  width: 82% !important;
  padding-left: 0.24rem;
}
.van-cell {
  background: #fffbf1;
}
.myPrize .van-cell {
  padding: 0.32rem 0.4rem !important;
}
.default {
  width: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>